type Locale = 'cs' | 'en' | 'nl' | 'sk' | 'de';

import cs from './compiled/cs.json';
import en from './compiled/en.json';
import nl from './compiled/nl.json';
import sk from './compiled/sk.json';
import de from './compiled/de.json';

export const messages: Record<Locale, Record<string, string>> = {
  cs,
  en,
  nl,
  sk,
  de,
};
